<template>
    <footer>
        <div class="content">
            <b-row>
                <b-col cols="12" md>
                    <ul class="menu" v-if="lang == 'eng'">
                        <li>
                            <router-link to="/Nosotros">About Us</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'Home', hash: '#servicios'}">Services</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'Home', hash: '#ubicaciones'}">Locations</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'Home', hash: '#preguntas'}">FAQ</router-link>
                        </li>
                        <li>
                            <router-link to="/Noticias">Notices</router-link>
                        </li>
                    </ul>
                    <ul class="menu" v-else-if="lang == 'esp'">
                        <li>
                            <router-link to="/Nosotros">Nosotros</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'Home', hash: '#servicios'}">Servicios</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'Home', hash: '#ubicaciones'}">Ubicaciones</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'Home', hash: '#preguntas'}">Preguntas</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'Home', hash: '#noticias'}">Noticias</router-link>
                        </li>
                    </ul>
                </b-col>
                <b-col cols="12" md="auto">
                    <ul class="redes">
                        <li>
                            <a href="https://www.facebook.com/Border-Comercial-2322539974643327/" target="_blank"><img src="../assets/img/icn_facebook.svg" alt="Facebook"></a>
                        </li>
                        <!-- <li>
                            <a href="#!"><img src="../assets/img/icn_instagram.svg" alt="Instagram"></a>
                        </li>
                        <li>
                            <a href="#!"><img src="../assets/img/icn_youtube.svg" alt="Youtube"></a>
                        </li> -->
                    </ul>
                </b-col>
            </b-row>
        </div>
    </footer>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    export default {
        computed:{
            ...mapState(['lang'])
        }
    }
</script>

<style scoped>
    footer{
        background-color: #F14C28;
        padding: 30px 0 40px 0;
    }
    footer *{
        color: white!important;
    }
    ul li{
        display: inline-block;
    }
    ul.menu li{
        margin-right: 15px;
        cursor: pointer;
    }
    ul.redes li{
        margin-left: 15px;
    }
    .redes img{
        width: 80%;
    }
    @media screen and (max-width: 767px){
        footer{
            text-align: center;
        }
        ul.menu li{
            font-size: 9pt;
            margin: 0 3px;
        }
        ul.redes li{
            margin: 0 6px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue